import { render, staticRenderFns } from "./ContratoModalEditar.vue?vue&type=template&id=3ef587cc&"
import script from "./ContratoModalEditar.vue?vue&type=script&lang=ts&"
export * from "./ContratoModalEditar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports